import { revealSponsoredBanners } from './display';
import { initSponsoredBannersTracking } from './tracking';

export default function initSponsoredBanners() {
  if (!document.querySelector('.promotion-list-section')) {
    return;
  }

  revealSponsoredBanners();
  initSponsoredBannersTracking();
}
